import React from 'react';
import './searchBox.css';

const SearchBox = ({onSearchChange}) => {
	return(
		<div className='f3 pa3 ma2'>
			<h1 className='f1 pd2'>RoboFriends</h1>
			<input className='pa3 ba b--lightest-blue bg-lightest-blue shadow-5'
				type='search'
				placeholder='search robots'
				onChange = {onSearchChange}
			/>
		</div>
	);
}

export default SearchBox;